import { render, staticRenderFns } from "./StudentAppointments.vue?vue&type=template&id=46ca6f38&"
import script from "./StudentAppointments.vue?vue&type=script&lang=ts&"
export * from "./StudentAppointments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports